(function ($) {
    let sliderInstances = [];

    function initPeekSlider(el, options = {}) {
        const config = Object.assign({
            slidesPerView: 'auto',
            freeMode: true,
            observer: true,
            observeParents: true,
            observeSlideChildren: true, // navíc — sleduje i změny uvnitř slidů (např. obrázek, co se dotáhl)
            watchOverflow: true,
            watchSlidesVisibility: true,
            mousewheel: {
                forceToAxis: true,
            },
        }, options);

        const nextEl = el.querySelector('.swiper-button-next');
        const prevEl = el.querySelector('.swiper-button-prev');
        if (nextEl && prevEl) {
            config.navigation = { nextEl, prevEl };
        }

        const swiper = new Swiper(el.querySelector('.swiper-container'), config);

        sliderInstances.push(swiper);
        return swiper;
    }

    function initProductArchiveSliders() {
        document.querySelectorAll('.product-archive__categories_row').forEach((el) => {
            initPeekSlider(el, {
                spaceBetween: 64,
                breakpoints: {
                    0:    { spaceBetween: 16 },
                    768:  { spaceBetween: 16 },
                    1024: { spaceBetween: 64 },
                },
            });
        });

        document.querySelectorAll('.product-archive__models_row').forEach((el) => {
            initPeekSlider(el, { spaceBetween: 16 });
        });
    }

    initProductArchiveSliders();

    $(document).gp_ready(function () {
        initProductArchiveSliders();
    });

    // Klíčová oprava: po plném načtení stránky a po dotažení fontů
    // znovu přepočítat všechny instance, ať Swiper zná skutečnou šířku obsahu.
    window.addEventListener('load', () => {
        sliderInstances.forEach((s) => s.update());
    });

    if (document.fonts && document.fonts.ready) {
        document.fonts.ready.then(() => {
            sliderInstances.forEach((s) => s.update());
        });
    }
})(jQuery);